module.exports = __webpack_public_path__ + "static/media/onboarding-sketch.d83fc46d.jpg";